import { useBackendStore } from '@/stores/backendStore';
import { IBackend } from '@/api/BackendApi';

/**
 * Custom hook for accessing the backend API instance.
 * Returns the backend instance from the backend store.
 */
export function useBackend(): IBackend {
  return useBackendStore((state) => state.getBackend());
}
